// extracted by mini-css-extract-plugin
export default {"label":"FilterCheckbox_label__BgOSD","label__disabled":"FilterCheckbox_label__disabled__LR0CM","wrapper":"FilterCheckbox_wrapper__HsYeN"};